import script from "./JournalChapter.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalChapter.vue?vue&type=script&setup=true&lang=js"

import "./JournalChapter.vue?vue&type=style&index=0&id=e15067c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e15067c4"]])

export default __exports__